import { FC } from 'react';

import { cn } from 'utils/helpers';

interface PROPS {
  commentCount?: number;
  attachmentCount?: number;
  toggleComments: () => void;
  toggleAttachments: () => void;
}

const CommentAttachmentCounter: FC<PROPS> = ({
  commentCount = 0,
  attachmentCount = 0,
  toggleComments,
  toggleAttachments,
}) => (
  <div
    className={cn(
      commentCount || attachmentCount ? 'flex' : 'hidden',
      'font-semibold',
    )}
  >
    {!!attachmentCount && (
      <button
        onClick={toggleAttachments}
        type="button"
        className="hover:text-primary-base transition text-xs pr-3"
      >
        {`${attachmentCount} Attachments`}
      </button>
    )}
    {!!commentCount && !!attachmentCount && '|'}
    {!!commentCount && (
      <button
        type="button"
        onClick={toggleComments}
        className="hover:text-primary-base transition first:px-0 px-3 text-xs "
      >
        {`${commentCount} Comments`}
      </button>
    )}
  </div>
);

export default CommentAttachmentCounter;
